export const IJR = 2021
export const AJR = 2022
export const NettobestaansmiddelenPartnerMax = 3410
export const HqMax = 11170
